import { Combined } from "./Retail_Statics/Combined.jsx";
import { DayHourWise } from "./Retail_Statics/DayHourCombined.jsx";
import { PPLWise } from "./Retail_Statics/PPLWise.jsx";
import { KPI } from "./KPI/KPI.jsx";

import { CombinedTables } from "./Retail_Statics/CombinedTables.js";

const Retail = () => {
  return (
    <div className="flex flex-col flex-grow ">
      <div className="px-2 mt-2 relative">
        <KPI />
      </div>
      <div className="lg:flex gap-2 px-2 mb-2 md:block mt-2">
        <section className="lg:w-[75%] md:w-full">
          <div className="bg-white rounded-md">
            <DayHourWise />
          </div>
          <div className="lg:flex pt-2 gap-4 md:full">
            <div className="bg-white rounded-md lg:w-1/2 md:w-full">
              <CombinedTables />
            </div>
            <div className="bg-white rounded-md lg:w-1/2 md:w-full mt-5 md:mt-0 ">
              <Combined />
            </div>
          </div>
        </section>
        <section className="lg:w-[25%] md:w-full mt-5 md:mt-0">
          <PPLWise />
        </section>
      </div>
    </div>
  );
};

export default Retail;
